import { defineStore } from 'pinia'
import type { LogoContent } from '~/types/cms'

export class CarrierStore {
  static use = defineStore('carriers', () => {
    const logoCatalog = ref<Record<string, string>>({})
    const getKey = (key: string, planYear: string | number) => `${key}-${planYear}`

    const getLogo = (key: string, planYear: string | number) => {
      const exact = logoCatalog.value[getKey(key, planYear)]
      if (!_isNil(exact)) return exact

      // if no logo for the carrier + year has been added to Directus yet, fall back to most recent year
      const prefix = `${key}-`
      const mostRecentYear = Object.keys(logoCatalog.value)
        .filter((k) => k.startsWith(prefix))
        .map((k) => Number(k.slice(prefix.length)))
        .filter((y) => !isNaN(y))
        .sort((a, b) => b - a)[0]

      return _isNil(mostRecentYear) ? undefined : logoCatalog.value[getKey(key, mostRecentYear)]
    }

    async function load() {
      const { getCarrierLogoContent } = Cms.use()

      const logosPromise = getCarrierLogoContent()

      const { logos } = await logosPromise
      logoCatalog.value = logos.value.reduce(
        (acc: Record<string, string>, x: LogoContent) => ({
          ...acc,
          [getKey(x.key, x.planYear)]: x.fileName
        }),
        {} as Record<string, string>
      )
    }

    return {
      logoCatalog,
      getLogo,
      load
    }
  })

  static async load() {
    const store = CarrierStore.use()
    await store.load()
  }
}
